import React from 'react';
import { Card, Grid } from '@mui/material';
import { styled } from '@mui/system';
import { Zoom } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css';
import { Link } from 'react-router-dom';
import { saveToLocalStorage } from '../../../Helper/helper';

const AdvertiseItem = styled(Card)({
    height: '100%',
    width: '100%',
    background: 'rgba(255, 255, 255, 0.5)',
    backdropFilter: 'blur(12px) saturate(160%)',
    WebkitBackdropFilter: 'blur(12px) saturate(160%)',
    border: '1px solid rgba(255, 255, 255, 0.5)',
    borderRadius: 10,
    padding: 6,
    boxShadow: '0 2px 8px rgba(28, 35, 101, 0.06)',
});

function Advertise({ bannerAds }) {
    const hasMultipleAds = bannerAds.length > 1;

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={4} lg={4}>
                <AdvertiseItem>
                    <Link to={`/user/matrimony`} onClick={()=>{saveToLocalStorage(window.location.pathname, window.scrollY);}}>
                        <img alt="Ad 1" src="/UserSideImages/matrimonial-redirect.jpeg" style={{ width: '100%', height: 150, borderRadius: 5, objectFit: 'cover' }} />
                    </Link>
                </AdvertiseItem>
            </Grid>
            <Grid item xs={12} sm={12} md={8} lg={8}>
                <AdvertiseItem>
                    <div className="slide-container">
                        {hasMultipleAds ? (
                            <Zoom scale={0.4} defaultIndex={0}>
                                {bannerAds.map((each, index) => (
                                    <Link to={each?.link} key={index}>
                                        <div style={{ width: "100%", aspectRatio: "6.5 / 1", borderRadius: 5, background: "#f4f5fa", overflow: "hidden" }}>
                                            <img style={{ width: "100%", height: "100%", objectFit: "cover" }} src={each?.image?.url} alt={`Ad ${index + 1}`} />
                                        </div>
                                    </Link>
                                ))}
                            </Zoom>
                        ) : (
                            <Link to={bannerAds[0]?.link}>
                                <div style={{ width: "100%", aspectRatio: "6.5 / 1", borderRadius: 5, background: "#f4f5fa", overflow: "hidden" }}>
                                    <img style={{ width: "100%", height: "100%", objectFit: "cover" }} src={bannerAds[0]?.image?.url} alt="Ad" />
                                </div>
                            </Link>
                        )}
                    </div>
                </AdvertiseItem>
            </Grid>
        </Grid>
    );
}

export default Advertise;
